module.exports = __webpack_public_path__ + "static/MMV_award_image.c536589c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news/MMV_award_image.jpg
// module id = 387
// module chunks = 22846268747618 46636455185173